import * as runtime from '@/api/runtime'

export interface BatchLendInfoExtractApi {
  data: FormData
}

/**
 * DAMファイルDL
 */
export class BatchLendInfoExtractApi extends runtime.BaseAPI {
  async return(lendDate: string): Promise<number> {
    const queryParameters: runtime.HTTPQuery = { lend_date: lendDate }
    const response = await this.requestGet(
      `/batch/lend/lend-info-extract`,
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
